<template>
  <div>
    Edit Task Progress
  </div>
</template>

<script>
export default {
  name: 'Window.Task.Progress.Edit'
}
</script>

<style scoped>

</style>
